import { Order, Stats } from "../../types";

// Enhanced types for shipping tracking
export interface ShippingStats {
    total: number;
    byStatus: { [key: string]: number };
    supportedCountries: string[];
    lastUpdate: string;
}

export interface EnhancedStats extends Stats {
    byCountry?: { [key: string]: number };
    byCategory?: { [key: string]: number };
    packagingOrders?: number;
    shippingOrders?: number;
}

export interface Shipment {
    orderId: number;
    trackingId: string;
    country: string;
    shippingCompany: string;
    status: string;
    createdAt: string;
    updatedAt: string;
    customerData: {
        name: string;
        address: string;
        city: string;
        phone: string;
    };
    statusHistory: Array<{
        status: string;
        timestamp: string;
        source: string;
    }>;
}

export interface AnalyticsData {
    totalOrders: number;
    byStatus: { [key: string]: number };
    byCountry: { [key: string]: number };
    byCategory: { [key: string]: number };
    packagingOrders: number;
    shippingOrders: number;
    lastUpdate: string;
}

export interface StatusInfo {
    name: string;
    color: string;
    icon: React.ReactNode;
    category: string;
}

export interface MongoDBStatus {
    connected: boolean;
    lastUpdate: string;
}

export type TabType = "orders" | "shipping" | "analytics";

export type SortByType = "id" | "name" | "status" | "country" | "price" | "time";
export type SortOrderType = "asc" | "desc";

// Country flag mapping
export const getCountryFlag = (countryCode: string): string => {
    const flags: { [key: string]: string } = {
        mk: "🇲🇰", // Macedonia
        rs: "🇷🇸", // Serbia
        bg: "🇧🇬", // Bulgaria
        gr: "🇬🇷", // Greece
        al: "🇦🇱", // Albania
        ks: "🇽🇰", // Kosovo
        me: "🇲🇪", // Montenegro
        ba: "🇧🇦", // Bosnia and Herzegovina
        hr: "🇭🇷", // Croatia
        si: "🇸🇮", // Slovenia
        ro: "🇷🇴", // Romania
        hu: "🇭🇺", // Hungary
        cz: "🇨🇿", // Czech Republic
        sk: "🇸🇰", // Slovakia
        pl: "🇵🇱", // Poland
        de: "🇩🇪", // Germany
        at: "🇦🇹", // Austria
        ch: "🇨🇭", // Switzerland
        it: "🇮🇹", // Italy
        fr: "🇫🇷", // France
        es: "🇪🇸", // Spain
        pt: "🇵🇹", // Portugal
        nl: "🇳🇱", // Netherlands
        be: "🇧🇪", // Belgium
        uk: "🇬🇧", // United Kingdom
        gb: "🇬🇧", // Great Britain
        ie: "🇮🇪", // Ireland
        dk: "🇩🇰", // Denmark
        se: "🇸🇪", // Sweden
        no: "🇳🇴", // Norway
        fi: "🇫🇮", // Finland
        us: "🇺🇸", // United States
        ca: "🇨🇦", // Canada
        au: "🇦🇺", // Australia
    };

    return flags[countryCode?.toLowerCase()] || "🏳️";
};

// Country mapping with flags
export const countryFlags: { [key: string]: string } = {
    mk: "🇲🇰",
    bg: "🇧🇬",
    rs: "🇷🇸",
    gr: "🇬🇷",
    us: "🇺🇸",
    de: "🇩🇪",
    fr: "🇫🇷",
    gb: "🇬🇧",
    it: "🇮🇹",
    es: "🇪🇸",
    ca: "🇨🇦",
    au: "🇦🇺",
    jp: "🇯🇵",
};
